// extracted by mini-css-extract-plugin
export default {"preventScroll":"G15bed5","left":"Gcd6943","center":"G3df5a2","right":"G4556e1"};